import { SxProps, Theme } from '@mui/material';

// Reusable style constants
export const iconContainerStyles: SxProps<Theme> = {
  width: 32,
  height: 32,
  minWidth: 32,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  bgcolor: '#ffebee',
  color: 'error.dark',
};

export const contentContainerStyles: SxProps<Theme> = {
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
};

export const titleTextStyles: SxProps<Theme> = {
  fontSize: '0.875rem',
  fontWeight: 500,
  color: 'text.primary',
  lineHeight: 1.25,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const secondaryTextStyles: SxProps<Theme> = {
  fontSize: '0.75rem',
  color: 'text.secondary',
  lineHeight: 1.25,
  mt: 0.25,
};

export const overflowTextStyles: SxProps<Theme> = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const separatorStyles: SxProps<Theme> = {
  mx: 0.5,
  opacity: 0.4,
};

export const itemContainerStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  px: 2,
  py: 1,
  minHeight: '52px',
  cursor: 'pointer',
  transition: 'background-color 0.2s',
  '&:hover': {
    bgcolor: 'action.hover',
  },
  '&:active': {
    bgcolor: 'action.selected',
  },
};

export const sectionHeaderStyles: SxProps<Theme> = {
  px: 2,
  py: 0.75,
  fontSize: '0.75rem',
  fontWeight: 500,
  color: 'text.secondary',
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  position: 'sticky',
  top: 0,
  bgcolor: 'background.paper',
  backdropFilter: 'blur(4px)',
  zIndex: 10,
};
